
import CategoryRoutes from './Category/router';

const Index = () => import(/* webpackChunkName: "account" */ './index.vue');
const List = () => import(/* webpackChunkName: "account" */ './components/List.vue');
// const InventoryAdj = () => import(/* webpackChunkName: "account" */ './components/InventoryAdj.vue');
const Home = () => import(/* webpackChunkName: "account" */ './view/Home.vue');

let routes = [];
routes = routes.concat(CategoryRoutes);



routes = routes.concat([
  {
  path: 'home',
  name: 'category-home',
  component: Home,
},
{
  path: 'list',
  name: 'product-list',
  component: List,
},
// {
//   path: 'inventoryAdj/:id',
//   name: 'inventory-adj',
//   component: InventoryAdj,
// },
]);

export default [{
path: '/product',
redirect: { name: 'product-home' },
component: Index,
children: routes,
}];

// export default [
//   {
//     path: 'account',
//     name: 'account',
//     component: Index,
//     title: 'account',
//     redirect: { name: 'product-list' },
//     children: [
//       {
//         path: 'list',
//         name: 'product-list',
//         component: List,
//       },
//       // {
//       //   path: 'edit',
//       //   name: 'account-edit',
//       //   component: Edit,
//       // },
//     ],
//   },
// ]
